import { ComponentManager, DataTransferObject } from 'radpresentation.htmlclient.defaultviewextensions';

export default class WFEMemberUIDTO extends DataTransferObject {
    public Editable: any;
    public Name: any;
    public Visible: any;

    constructor() {
        super({xmlProperties: ['Editable', 'Name', 'Visible'], xmlNamespace: 'WorkflowEngine'});

        this.Editable = this.observableOrDefault(this.defaultFromType('bool'));
        this.Name = this.observableOrDefault(this.defaultFromType('string'));
        this.Visible = this.observableOrDefault(this.defaultFromType('bool'));
    }
}

ComponentManager.setModel('WFEMemberUIDTO', WFEMemberUIDTO, 'WorkflowEngineHTMLViewExtension');